<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="PersonalRoles.saveError">
    <template slot="center">
      <el-form
         label-width="25%"
        :rules="rules"
        :ref="formRef"
        :model="formData"
        :label-position="labelPosition">

        <section>
          <div class="section-items">
            <el-form-item
               prop="roles"
              :label="$t('label.roles')">
              <el-transfer
                 v-model="formData.roles"
                :disabled="!edit"
                :filterable="false"
                :data="availableRoles"
                :titles="options.titles"
                :button-texts="options.buttons">
              </el-transfer>
            </el-form-item>
          </div>

          <div class="section-help">
            <p v-html="_markdown.render($t('label.personal_roles_help'))"></p>
            <p></p>
            <br>
            <p><strong>{{ $t('label.professional_roles_are') }}:</strong></p>
            <ul>
              <li v-for="role in professionalRoles">{{ $t(`label.${role}`) }}</li>
            </ul>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row">
        <el-button type="primary" size="small" :loading="isSaving" @click="submitForm">{{ $t('label.save') }}</el-button>
        <el-button type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { get, map, filter, includes, intersection, size } from 'lodash';
import { SCOPES, INSTANCE_OWNER } from 'constants/roles';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-my-preferences-personal-roles',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'top',
    },
    PersonalRoles: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      options: {
        props: {
          key: 'id',
          label: 'name',
        },
        available_roles: [],
        titles: [this.$t('label.available_roles'), this.$t('label.assigned_roles')],
        buttons: [this.$t('label.remove'), this.$t('label.add')],
      },
      formData: {
        roles: [],
      },
      rules: {
        roles: [
          {
            min: 1,
            type: 'array',
            required: true,
            trigger: 'change',
            validator: this.validateStaffRoles,
            message: this.formatValidationMessage('validation.at_least_one_required', 'label.professional_role', true),
          },
        ],
      },
    };
  },
  computed: {
    availableRoles() {
      const availableRoles = get(this.PersonalRoles, 'data.AvailableRoles', []);
      return map(availableRoles, item => ({
        key: item.id,
        label: item.name,
        disabled: !this.edit || item.scope === INSTANCE_OWNER,
      }));
    },
    professionalRoles() {
      const availableRoles = get(this.PersonalRoles, 'data.AvailableRoles', []);
      const availableRolesMap = map(availableRoles, 'scope');
      return intersection(availableRolesMap, SCOPES.STAFF);
    },
  },
  methods: {
    getSelectedRoleCodes(roles) {
      const availableRoles = get(this.PersonalRoles, 'data.AvailableRoles', []);
      const selectedRoleCodes = map(filter(availableRoles, item => includes(roles, item.id)), 'scope');
      return intersection(selectedRoleCodes, SCOPES.STAFF);
    },
    validateStaffRoles(rule, value, callback) {
      const test = this.getSelectedRoleCodes(value);
      if (size(test) === 0) callback(new Error());
      else callback();
    },
    setFormData() {
      const selectedRoles = get(this.PersonalRoles, 'data.SelectedRoles', []);
      this.formData.roles = map(selectedRoles, 'id');
    },
    getFormData() {
      return this.clone(this.formData);
    },
  },
  created() {
    this.stateData = this.PersonalRoles;
    this.formRef = 'form-my-preferences-personal-roles';
    this.setFormData();
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .el-transfer {
    .el-transfer-panel {
      width: 35%;
      min-width: 200px;
    }
    .el-transfer__buttons {
      width: 30%;
      min-width: 150px;
      text-align: center;

      .el-button {
        width: 80%;
        min-width: 150px;
        display: inline-block;
        i.el-icon-arrow-left {
          margin-right: 0.25em;
        }
        i.el-icon-arrow-right {
          margin-left: 0.25em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/roles/form-my-preferences-personal-roles.vue